import TBreadcrumb from './breadcrumb.vue'
import TBreadcrumbItem from './breadcrumb-item.vue'

TBreadcrumb.Item = TBreadcrumbItem

TBreadcrumb.install = Vue => {
  Vue.component(TBreadcrumb.name, TBreadcrumb)
}

TBreadcrumbItem.install = Vue => {
  Vue.component(TBreadcrumbItem.name, TBreadcrumbItem)
}

export {
  TBreadcrumb,
  TBreadcrumbItem
}



// WEBPACK FOOTER //
// ./src/module/breadcrumb/index.js